import { useEffect, useState } from "react";
import { api, type Settings, setToken } from "../api/client";

export function SettingsPage() {
  const [settings, setSettings] = useState<Settings | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api.settings().then(setSettings).catch((e) => setErr(String(e)));
  }, []);

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-xl font-semibold">Настройки</h1>
        <p className="text-sm text-panel-muted">
          Значения задаются в `.env` на сервере. Здесь — только просмотр статуса интеграций.
        </p>
      </header>
      {err && <div className="card pill-err border-panel-err">Ошибка: {err}</div>}

      {settings && (
        <>
          <section className="card">
            <h2 className="mb-2 text-sm font-medium">Окружение</h2>
            <dl className="grid grid-cols-2 gap-1 text-sm">
              <dt className="text-panel-muted">NODE_ENV</dt>
              <dd>{settings.env}</dd>
              <dt className="text-panel-muted">Panel URL</dt>
              <dd>{settings.panel_url}</dd>
              <dt className="text-panel-muted">HTTPS_PROXY</dt>
              <dd>
                <span className={`pill ${settings.proxy.https_proxy === "set" ? "pill-ok" : "pill-warn"}`}>
                  {settings.proxy.https_proxy}
                </span>
              </dd>
            </dl>
          </section>

          <section className="card">
            <h2 className="mb-2 text-sm font-medium">Интеграции</h2>
            <ul className="space-y-1 text-sm">
              {Object.entries(settings.integrations).map(([k, v]) => (
                <li key={k} className="flex items-center justify-between">
                  <span className="text-panel-muted">{k}</span>
                  <span className={`pill ${v === "configured" ? "pill-ok" : "pill-warn"}`}>{v}</span>
                </li>
              ))}
            </ul>
            <p className="mt-3 text-xs text-panel-muted">
              Чтобы включить missing — добавь соответствующий ключ в `/opt/coagent-console/.env` и перезапусти backend.
            </p>
          </section>

          <section className="card">
            <h2 className="mb-2 text-sm font-medium">Автопилот</h2>
            <dl className="grid grid-cols-2 gap-1 text-sm">
              <dt className="text-panel-muted">Enabled</dt>
              <dd>
                <span className={`pill ${settings.autopilot.enabled ? "pill-ok" : "pill-warn"}`}>
                  {settings.autopilot.enabled ? "on" : "off"}
                </span>
              </dd>
              <dt className="text-panel-muted">Mode</dt>
              <dd>{settings.autopilot.mode}</dd>
              <dt className="text-panel-muted">Cron</dt>
              <dd>
                <code className="text-xs">{settings.autopilot.cron}</code>
              </dd>
            </dl>
          </section>

          <section className="card">
            <h2 className="mb-2 text-sm font-medium">Log watcher</h2>
            <dl className="grid grid-cols-2 gap-1 text-sm">
              <dt className="text-panel-muted">Enabled</dt>
              <dd>
                <span className={`pill ${settings.logwatch.enabled ? "pill-ok" : "pill-warn"}`}>
                  {settings.logwatch.enabled ? "on" : "off"}
                </span>
              </dd>
              <dt className="text-panel-muted">Interval</dt>
              <dd>{settings.logwatch.interval_sec}s</dd>
              <dt className="text-panel-muted">Sources</dt>
              <dd className="text-xs">{settings.logwatch.sources.join(", ")}</dd>
            </dl>
          </section>

          <section className="card">
            <h2 className="mb-2 text-sm font-medium">Сессия</h2>
            <button
              className="btn"
              onClick={() => {
                setToken(null);
                window.location.reload();
              }}
            >
              Выйти
            </button>
          </section>
        </>
      )}
    </div>
  );
}
